import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import HeadTabs from "./head-tabs";
import Body from "./body";

export const TAB_NAMES = {
  reviews: "Reviews",
  product_details: "Product Details",
};

export default function ProductInfo(props) {
  const reviewCount = useSelector(state => state.reviews?.count);
  const [tabSelected, setTabSelected] = useState(
    Number.isInteger(reviewCount) && reviewCount > 0 ? TAB_NAMES.reviews : TAB_NAMES.product_details
  );

  // in the GridProductDrawer, reviews.count is not available at the time of rendering
  // so let's set the tab to reviews if reviews.count is available after the component has mounted
  useEffect(() => {
    if (Number.isInteger(reviewCount) && reviewCount > 0) {
      setTabSelected(TAB_NAMES.reviews);
    }
  }, [reviewCount]);

  const isMobileViewport = useSelector(state => !!state.browser?.isMobileViewport);
  const isBuyNow = useSelector(state => !!state.isBuyNow);
  if (!isMobileViewport) {
    return;
  }

  return (
    <div className="pdp-product-info" data-test-id="pdp-product-info">
      <HeadTabs tabSelected={tabSelected} setTabSelected={setTabSelected} TAB_NAMES={TAB_NAMES} />
      <Body
        isBuyNow={isBuyNow}
        isMobileViewport={isMobileViewport}
        images={props.images}
        imageRotation={props.imageRotation}
        displayName={props.displayName}
        designerDisplayName={props.designerDisplayName}
        productId={props.productId}
        fitNotes={props.fitNotes}
        stylistNotes={props.stylistNotes}
        productDetails={props.productDetails}
        logReadAllReviews={props.logReadAllReviews}
        TAB_NAMES={TAB_NAMES}
        tabSelected={tabSelected}
      />
    </div>
  );
}

ProductInfo.propTypes = {
  images: PropTypes.object,
  imageRotation: PropTypes.arrayOf(PropTypes.object),
  displayName: PropTypes.string,
  designerDisplayName: PropTypes.string,
  productId: PropTypes.string,
  fitNotes: PropTypes.string,
  stylistNotes: PropTypes.string,
  productDetails: PropTypes.string,
  logReadAllReviews: PropTypes.func,
};
